<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="formgrid grid">
        <div class="field col-12">
          <label
            :class="{
              'p-error': v$.form.account.$invalid && submitted,
            }"
          >
            Perkiraan
          </label>
          <Dropdown
            v-model="form.account"
            :options="list_account"
            optionLabel="nama"
            placeholder="Pilih Perkiraan"
            class="w-full"
            filter
            showClear
            :class="{
              'p-invalid': v$.form.account.$invalid && submitted,
            }"
          >
            <template #option="slotProps">
              <div>
                <span v-if="slotProps.option.level === 2"
                  >&nbsp;&nbsp;&nbsp;</span
                >
                <span v-if="slotProps.option.level === 3"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                >
                <span v-if="slotProps.option.level === 4"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                >
                <small>{{ slotProps.option.kode }}</small
                >&nbsp;{{ slotProps.option.nama }}
              </div>
            </template>
          </Dropdown>
          <small
            v-if="
              (v$.form.account.$invalid && submitted) ||
              v$.form.account.$pending.$response
            "
            class="p-error"
            >{{ v$.form.account.required.$message }}</small
          >
        </div>
        <div class="field col-12">
          <label
            :class="{
              'p-error': v$.form.keterangan.$invalid && submitted,
            }"
          >
            Keterangan</label
          >
          <InputText
            v-model="form.keterangan"
            type="text"
            :class="{
              'p-invalid': v$.form.keterangan.$invalid && submitted,
            }"
            class="w-full"
          />
          <small
            v-if="
              (v$.form.keterangan.$invalid && submitted) ||
              v$.form.keterangan.$pending.$response
            "
            class="p-error"
            >{{ v$.form.keterangan.required.$message }}</small
          >
        </div>
        <div class="field col-12">
          <label>No. Referensi</label>
          <InputText v-model="form.reff_no" type="text" class="w-full" />
        </div>
        <div class="field col-12">
          <label
            :class="{
              'p-error': v$.form.nilai.$invalid && submitted,
            }"
          >
            Nilai
          </label>
          <InputNumber
            v-model="form.nilai"
            :minFractionDigits="0"
            :maxFractionDigits="2"
            :class="{
              'p-invalid': v$.form.nilai.$invalid && submitted,
            }"
            mode="currency"
            currency="IDR"
            locale="id-ID"
            class="w-full"
            input-class="w-full"
            @keydown="onNumpadDecimal"
          />
          <div
            v-if="
              (v$.form.nilai.$invalid && submitted) ||
              v$.form.nilai.$pending.$response
            "
            class="p-error"
          >
            <small>{{ v$.form.nilai.between.$message }}</small>
          </div>
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          label="Tutup"
          icon="pi pi-times"
          @click="onCloseForm"
          class="p-button-outlined mr-2"
        />
        <Button
          v-if="item.uuid"
          label="Ubah"
          icon="pi pi-check"
          type="submit"
        />
        <Button v-else label="Tambahkan" icon="pi pi-check" type="submit" />
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { between, helpers, required } from '@vuelidate/validators'
import errorHandler from '@/helpers/error-handler'
import AccountService from '@/services/AccountService'
import { formatNumber } from '@/helpers'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    id: {
      type: Number,
      default: 0,
    },
    saldo: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      submitted: false,
      accountService: null,
      acAccount: [],
      list_account: [],
      form: this.item,
    }
  },
  created() {
    this.accountService = new AccountService()
  },
  async mounted() {
    const res = await this.accountService.get()
    this.list_account = res.data.data
  },
  methods: {
    searchAccount(e) {
      this.accountService
        .get('?filter[nama]=' + e.query)
        .then((res) => {
          this.acAccount = res.data.data
        })
        .catch((err) => {
          errorHandler(err, 'Data Perkiraan', this)
        })
    },
    onCloseForm() {
      this.$emit('close')
    },
    handleSubmit(isFormValid) {
      this.submitted = true

      if (!isFormValid) {
        return
      }

      this.$emit('save', this.form)
      this.reset()
    },
    reset() {
      this.submitted = false
      this.form = {
        account: null,
        keterangan: '',
        reff_no: '',
        nilai: 0,
      }
      this.$refs.account.$el.children[0].focus()
    },
    getSaldo() {
      if (this.item.id > 0) {
        return (
          this.item.lastNilai + this.saldo + Math.abs(this.item.selisihNilai)
        )
      } else {
        if (this.item.selisihNilai) {
          return this.saldo + Math.abs(this.item.selisihNilai)
        } else {
          return this.saldo
        }
      }
    },
    formatNumber(value) {
      value = value ? value : 0
      return formatNumber(value)
    },
    onNumpadDecimal(e) {
      if (!(e.key === '.' || e.key === ',' || e.code === 'NumpadDecimal')) return

      let input = e.target
      if (!input) return
      if (input.tagName !== 'INPUT') input = input.querySelector && input.querySelector('input')
      if (!input || input.tagName !== 'INPUT') return

      e.preventDefault()

      try {
        const raw = input.value ?? ''

        const prefixMatch = raw.match(/^[^\d\-]*/u)
        const prefix = prefixMatch ? prefixMatch[0] : ''

        const numeric = raw.slice(prefix.length)

        const startGlobal = input.selectionStart ?? raw.length
        const endGlobal = input.selectionEnd ?? startGlobal
        const start = Math.max(0, startGlobal - prefix.length)
        const end = Math.max(0, endGlobal - prefix.length)

        const inserted = numeric.slice(0, start) + ',' + numeric.slice(end)

        const cleaned = inserted.replace(/\./g, '').replace(/\s/g, '')
        const parts = cleaned.split(',')
        let intPart = (parts[0] || '0').replace(/[^\d\-]/g, '')
        let fracPart = (parts[1] || '').replace(/[^\d]/g, '')
        const isNegative = intPart.startsWith('-')
        intPart = intPart.replace('-', '') || '0'

        if (fracPart.length === 0) {
          const formattedInt = new Intl.NumberFormat('id-ID').format(parseInt(intPart, 10) || 0)
          const formattedNumeric = `${isNegative ? '-' : ''}${formattedInt},`
          input.value = prefix + formattedNumeric

          const caretPos = prefix.length + formattedNumeric.indexOf(',') + 1
          try { input.setSelectionRange(caretPos, caretPos) } catch (_) {}
        } else {
          const num = parseFloat(intPart + '.' + fracPart) || 0
          const rounded = Math.round(num * 100) / 100

          const absVal = Math.abs(rounded)
          const integer = Math.trunc(absVal)
          const frac = Math.round((absVal - integer) * 100)
          const fracStr = String(frac).padStart(2, '0')

          const formattedInt = new Intl.NumberFormat('id-ID').format(integer)
          const formattedNumeric = `${isNegative ? '-' : ''}${formattedInt},${fracStr}`

          input.value = prefix + formattedNumeric

          const caretPos = input.value.length
          try { input.setSelectionRange(caretPos, caretPos) } catch (_) {}
        }

        input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: ',' }))
        try { input.dispatchEvent(new Event('change', { bubbles: true })) } catch (_) {}
      } catch (err) {
        errorHandler(err, 'Input Decimal', this)
      }
    },
  },
  validations() {
    return {
      form: {
        account: {
          required: helpers.withMessage('Perkiraan harus diisi.', required),
        },
        keterangan: {
          required: helpers.withMessage('Keterangan harus diisi.', required),
        },
        nilai: {
          required: helpers.withMessage(
            'Nilai harus di antara 1 dan ' +
              formatNumber(this.getSaldo()) +
              '.',
            required
          ),
          between: helpers.withMessage(
            'Nilai harus di antara 1 dan ' +
              formatNumber(this.getSaldo()) +
              '.',
            between(1, this.getSaldo())
          ),
        },
      },
    }
  },
}
</script>
